import { useEffect } from "react";
import { useSiteSettings } from "@/lib/settings";

/**
 * Loads Google Analytics (GA4) once when a Measurement ID is configured
 * in Site Settings. No-op when the ID is empty.
 */
export default function AnalyticsLoader() {
  const { settings } = useSiteSettings();
  const gaId = settings?.seo?.google_analytics_id;

  useEffect(() => {
    if (!gaId) return;
    if (document.getElementById("ga4-script")) return;

    const script = document.createElement("script");
    script.id = "ga4-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    const inline = document.createElement("script");
    inline.id = "ga4-inline";
    inline.text = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);} 
gtag('js', new Date());
gtag('config', '${gaId}');`;
    document.head.appendChild(inline);
  }, [gaId]);

  return null;
}
